import User from '@/packages/auth/User';
import Axios from '@/packages/axios/Axios';
import router from '@/router/routes';
import Vue from 'vue';

export default {
  actions: {
    async fetch_user(context) {
      await Axios.get('/v1/users')
        .then((response) => {
          const user = new User(response.data);
          // add roles to user object
          user.isSuperAdmin = user.isSuperAdmin();
          user.isIgnitionAdmin = user.isIgnitionAdmin();
          user.isClientAdminUser = user.isClientAdminUser();
          user.isClientUser = user.isClientUser();

          context.commit('SET_AUTHENTICATED_USER', user);
        })
        .catch((error) => {
          // don't check if we are resetting the password
          if (!window.location.href.toLowerCase().includes('reset-password')) {
            if (error.response.status === 401) {
              // clear tokens etc and bounce to login
              localStorage.removeItem('access_token');
              localStorage.removeItem('expiration');
              localStorage.removeItem('refresh_token');
              localStorage.removeItem('token_type');
              // clear tokens etc and bounce to login
              localStorage.removeItem('access_token');
              localStorage.removeItem('expiration');
              localStorage.removeItem('refresh_token');
              localStorage.removeItem('token_type');
              context.commit('SET_AUTHENTICATED_USER', undefined);
              router.push('/');
            } else {
              // clear tokens etc and bounce to login
              localStorage.removeItem('access_token');
              localStorage.removeItem('expiration');
              localStorage.removeItem('refresh_token');
              localStorage.removeItem('token_type');
              // clear tokens etc and bounce to login
              localStorage.removeItem('access_token');
              localStorage.removeItem('expiration');
              localStorage.removeItem('refresh_token');
              localStorage.removeItem('token_type');
              context.commit('SET_AUTHENTICATED_USER', undefined);
              router.push('/');
            }
          }
        });
    },
    logout({ commit }) {
      commit('SET_AUTHENTICATED_USER', undefined);
    },
  },
  getters: {
    current_user(state) {
      return state.authenticatedUser;
    },
  },
  mutations: {
    SET_AUTHENTICATED_USER(state, newUserInfo) {
      if (newUserInfo) {
        Vue.set(state, 'authenticatedUser', {});
        const lKeys = Object.keys(newUserInfo);
        for (let i = 0; i < lKeys.length; i++) {
          Vue.set(state.authenticatedUser, lKeys[i], newUserInfo[lKeys[i]]);
        }
      } else {
        Vue.set(state, 'authenticatedUser', undefined);
      }
    },
  },
  state: {
    authenticatedUser: undefined,
  },
};
